export default "__VITE_ASSET__C9WThPUW__"